import React, { useState } from 'react';
import { Spinner, ErrorBox, EmptyState } from './UI';
import { useTeams } from '../hooks/useApi';

export default function TeamsList({ season }) {
  const { teams, loading, error } = useTeams(season?.seasonId);
  const [search, setSearch] = useState('');

  if (loading) return <Spinner label="Caricamento squadre…" />;
  if (error)   return <ErrorBox message={`Impossibile caricare le squadre: ${error}`} />;
  if (!teams.length) return <EmptyState icon="👕" title="Nessuna squadra disponibile" />;

  const filtered = teams.filter(t => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      (t.officialName  || '').toLowerCase().includes(q) ||
      (t.shortName     || '').toLowerCase().includes(q) ||
      (t.mediaName     || '').toLowerCase().includes(q) ||
      (t.acronymName   || '').toLowerCase().includes(q)
    );
  });

  return (
    <section className="selector-section">
      <div className="section-header-row">
        <h2 className="section-title">
          Squadre — <span className="section-sub">{season.seasonName}</span>
        </h2>
        <input
          className="search-input"
          type="search"
          placeholder="Cerca squadra…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {filtered.length === 0 ? (
        <EmptyState icon="🔍" title="Nessuna squadra trovata"
          subtitle={`Nessun risultato per "${search}"`} />
      ) : (
        <div className="teams-grid">
          {filtered.map((team, idx) => {
            const id       = team.teamId || team.id || String(idx);
            const acronym  = team.acronymName || team.acronymNameLocalized || '';
            const name     = team.officialName || team.shortName || team.mediaName || id;
            const sub      = team.mediaName && team.mediaName !== name ? team.mediaName : '';
            const country  = team.countryCode || '';

            return (
              <div key={`team-${id}-${idx}`} className="team-card">
                <span className="team-acronym">{acronym || name.slice(0, 3).toUpperCase()}</span>
                <span className="team-name">{name}</span>
                {sub     && <span className="team-media-name">{sub}</span>}
                {country && <span className="team-media-name">{country}</span>}
              </div>
            );
          })}
        </div>
      )}

      <p className="count-label">
        {filtered.length} squadr{filtered.length === 1 ? 'a' : 'e'}
      </p>
    </section>
  );
}
